import { Alert } from "@mui/material";

type Props = {
  message: string;
  variant: any;
  severity: any
  onClose: () => void;
};
const CommonAlert: React.FC<Props> = ({ message, variant, severity, onClose }) => (
  <Alert variant={variant} severity={severity} onClose={onClose}
    style={{ marginTop: '6px', padding: '2px', paddingLeft: '12px', paddingRight: '12px' }}>
    {message}
  </Alert>
);

export default CommonAlert;